import React from 'react';
import { TextStyleProps } from 'types';
import { buildHeaderStyle } from 'lib/buildTextStyle';

type TextProps = {
  children: string | string[];
  className?: string;
} & TextStyleProps;

export default function Header({
  children,
  className,
  ...rest
}: TextProps) {
  return (
    <h1 className={className} style={buildHeaderStyle(rest)}>
      {children}
    </h1>
  );
}
